import React from 'react';
import clsx from 'clsx';
import { Button, ButtonGroup } from 'components';
import './style.scss';
import { useSelector } from 'react-redux';
import { IState } from 'services/root-reducer';

export interface IMapZoomControl {
    className?: string,
    map: any,
    settings: {
        min_zoom: number
        zoom: number
        max_zoom: number
        center: [ number, number ]
    }
}

export const MapZoomControl: React.FC<IMapZoomControl> = (props): JSX.Element => {
    const {
        className = '',
        map,
        settings
    } = props;

    const filtersWindowVisible = useSelector((state: IState) => state.app.filtersWindowVisible);

    const setZoom = (delta: number) => {
        let view = map.getView();
        let currentResolution = view.getResolution();
        if (currentResolution) {
            const newResolution = view.constrainResolution(currentResolution, delta);
            view.animate({
                resolution: newResolution,
                easing: omjs.ol.easing.easeOut,
                duration: 190
            });
        }
    };

    const toDefaultMapPosition = () => {
        let view = map.getView();
        view.animate({
            zoom: settings.zoom,
            center: settings.center,
            easing: omjs.ol.easing.easeOut,
            duration: 190
        });
    };

    const handleZoom = (delta: number): void => {
        let view = map.getView();
        let zoom = view.getZoom();
        if (delta === 1 && (zoom < settings.max_zoom)) {
            setZoom(delta);
        } else if (delta === -1 && zoom > settings.min_zoom) {
            setZoom(delta);
        }
    };

    const classes = clsx('group-vertical', 'oms-map-zoom-control', {
        'filters-opened': filtersWindowVisible
    }, className);

    return (
        <ButtonGroup orientation='vertical' noGaps className={classes}>
            <Button variant='black' className="plus" onClick={() => handleZoom(1)} />
            <Button variant='black' className="default" onClick={() => toDefaultMapPosition()} />
            <Button variant='black' className="minus" onClick={() => handleZoom(-1)} />
        </ButtonGroup>
    );
};
